import React from "react";

import "./HomeCollectionCss/ViewTestModal.css";
const ShowTestModal = ({ open, onClose, tests}) => {
  if (!open) return null;
  console.log("Tests in Modal:", tests);

  return (
    <div className="vtm-backdrop">
      <div className="vtm-modal">
        {/* Header */}
        <div className="vtm-header">
          <h3>Selected Tests</h3>
          <button className="vtm-close" onClick={onClose}>×</button>
        </div>

        {/* Body */}
        <div className="vtm-body">
          {tests.length === 0 ? (
            <p className="vtm-empty">No tests selected</p>
          ) : (
            <table className="vtm-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Test Name</th>
                  <th>Price (₹)</th>
                </tr>
              </thead>
              <tbody>
                {tests.map((test, index) => (
                  <tr key={test.id || index}>
                    <td>{index + 1}</td>
                    <td>{test.product}</td>
                    <td>{test.price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        {/* Footer */}
        {/* <div className="vtm-footer">
          <button className="vtm-btn" onClick={onClose}>Close</button>
        </div> */}
      </div>
    </div>
  );
};

export default ShowTestModal;
